<template>
  <icon-button icon="/static-appopensalud/img/icons/morillas-svg-icons/primary/add.svg" :text="btnText"></icon-button>
</template>

<script>

export default {
  name: 'add-button',
  props: {
    buttonText: {
      type: String,
      required: false,
      default () {
        return this.$t('add-btn')
      }
    },
    showTextOnMobile: Boolean
  },
  computed: {
    btnText () {
      return this.$uiHelpers.isMobile && !this.showTextOnMobile ? '' : this.buttonText
    }
  },
  data () {
    return {
      hover: false
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/base/buttons/AddButton.vue